import React, { Fragment, useState, useEffect, useRef } from 'react'
import SiteHeader from '../../../components/SiteHeader';
import HeroSlider from '../../../components/HeroSlider'
import About from '../../../components/About'
import ServiceArea from '../../../components/ServiceArea'
import WhyChooseUs from '../../../components/WhyChooseUs'
import Statistics from '../../../components/Statistics'
import Testimonials from '../../../components/Testimonials'
import CallToAction from '../../../components/CallToAction'
import ContactArea from '../../../components/ContactArea'
import BlogArea from '../../../components/BlogArea'
import FooterArea from '../../../components/FooterArea'
import Seo from '../../../components/Seo'
import { useLanguage } from '../../../i18n';
import Form from '../../../components/Form';
import { Dialog, DialogContent, DialogTitle, DialogActions, IconButton, Button, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

// images
import about from '../../../images/about/2.jpg'
import signature from '../../../images/about/1.png'

const disclaimerEn = `Disclaimer & Confirmation: As per the rules of the Bar Council of India, we are not permitted to solicit work and advertise. By clicking on the "I agree" below, the user acknowledges the following: There has been no advertisement, personal communication, solicitation, invitation or inducement of any sort whatsoever from us or any of our members to solicit any work through this website; The user wishes to gain more information about us for his/her own information and use; The information about us is provided to the user only on his/her specific request and any information obtained or materials downloaded from this website is completely at the user's volition and any transmission, receipt or use of this site would not create any lawyer-client relationship. The information provided under this website is solely available at your request for informational purposes only, should not be interpreted as soliciting or advertisement. We are not liable for any consequence of any action taken by the user relying on material / information provided under this website. In cases where the user has any legal issues, he/she in all cases must seek independent legal advice.`;

const disclaimerHi = `अस्वीकरण और पुष्टि: भारतीय बार काउंसिल के नियमों के अनुसार, हमें काम की मांग करने और विज्ञापन देने की अनुमति नहीं है। नीचे "मैं समझता/समझती हूं" पर क्लिक करके, उपयोगकर्ता निम्नलिखित को स्वीकार करता है: इस वेबसाइट के माध्यम से किसी भी काम की मांग करने के लिए हमारी ओर से या हमारे किसी भी सदस्य से किसी भी प्रकार का कोई विज्ञापन, व्यक्तिगत संचार, याचना, निमंत्रण या प्रलोभन नहीं दिया गया है; उपयोगकर्ता अपनी जानकारी और उपयोग के लिए हमारे बारे में अधिक जानकारी प्राप्त करना चाहता है; हमारे बारे में जानकारी उपयोगकर्ता को केवल उसके विशिष्ट अनुरोध पर प्रदान की जाती है और इस वेबसाइट से प्राप्त कोई भी जानकारी या डाउनलोड की गई सामग्री पूरी तरह से उपयोगकर्ता की इच्छा पर है और इस साइट का कोई भी प्रसारण, प्राप्ति या उपयोग किसी वकील-ग्राहक संबंध का निर्माण नहीं करेगा।`;

const HomePageOne = () => {
    const { language } = useLanguage();
    const disclaimer = language === 'hi' ? disclaimerHi : disclaimerEn;


    const [disclaimerOpen, setDisclaimerOpen] = useState(false);
    const [popupOpen, setPopupOpen] = useState(false);
    const whyChooseUsRef = useRef(null);

    // Not while react-snap prerenders: a dialog captured into the static HTML
    // would sit outside the React root and could never be closed.
    const isPrerender = typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';

    useEffect(() => {
        if (!isPrerender && !localStorage.getItem('disclaimerAccepted')) {
            setDisclaimerOpen(true);
        }
    }, [isPrerender]);

    const handleDisclaimerAccept = () => {
        localStorage.setItem('disclaimerAccepted', 'true');
        setDisclaimerOpen(false);
        window.dispatchEvent(new Event('disclaimer-accepted'));
    };

    const handleDisclaimerReject = () => {
        window.location.reload();
    };

    useEffect(() => {
        if (isPrerender || sessionStorage.getItem('queryPopupShown')) return;
        const observer = new IntersectionObserver(
            ([entry]) => {
                // One popup per visit: skip if the consultation popup was already shown.
                if (sessionStorage.getItem('leadPopupClosed')) {
                    observer.disconnect();
                    return;
                }
                if (entry.isIntersecting) {
                    setPopupOpen(true);
                    sessionStorage.setItem('queryPopupShown', 'true');
                    observer.disconnect();
                }
            },
            { threshold: 0.3 }
        );
        if (whyChooseUsRef.current) observer.observe(whyChooseUsRef.current);
        return () => observer.disconnect();
    }, [isPrerender]);

    return (
        <Fragment>
            <Seo path="/" />
            <SiteHeader />

            <main>
            <h1 style={{ position: 'absolute', width: '1px', height: '1px', padding: 0, margin: '-1px', overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 }}>
                Legal Corridor — Trusted Law Firm & Advocates in Delhi
            </h1>

            <HeroSlider className="heroSliderArea" />

            

            <About
                className="aboutArea"
                images={about}
                signature={signature}
            />


            <div ref={whyChooseUsRef}>
                <WhyChooseUs />
            </div>

                        <Statistics />


            <Dialog open={popupOpen} onClose={() => setPopupOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ m: 0, p: 2, background: '#1a2a4a', color: '#fff' }}>
                    {language === 'hi' ? 'निःशुल्क परामर्श के लिए अनुरोध करें' : 'Request a Free Consultation'}
                    <IconButton
                        onClick={() => setPopupOpen(false)}
                        sx={{ position: 'absolute', right: 8, top: 8, color: '#fff' }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ p: 0 }}>
                    <Form />
                </DialogContent>
            </Dialog>

            <ServiceArea className="ourServiceArea" />

            <Testimonials />

            <section id="contactArea">
                <ContactArea className="contactArea" />
            </section>

            <BlogArea
                className="blogArea"
                title="Latest News"
                subTitle="Legal Insights & Updates"
            />

            <CallToAction />

            <Dialog
                open={disclaimerOpen}
                maxWidth="sm"
                fullWidth
                disableEscapeKeyDown
                scroll="paper"
                PaperProps={{ sx: { m: { xs: 1.5, sm: 4 }, width: { xs: 'calc(100% - 24px)', sm: undefined }, maxHeight: { xs: 'calc(100% - 24px)', sm: 'calc(100% - 64px)' }, borderRadius: 3, overflow: 'hidden' } }}
            >
                <DialogTitle sx={{ background: '#1a2a4a', color: '#fff', fontWeight: 700, fontSize: '1.1rem', textAlign: 'center' }}>
                    {language === 'hi' ? 'अस्वीकरण और पुष्टि' : 'Disclaimer & Confirmation'}
                </DialogTitle>
                <DialogContent dividers sx={{ px: { xs: 2.5, sm: 3 } }}>
                    <Typography variant="body2" sx={{ fontSize: { xs: '14px', sm: '13.5px' }, lineHeight: 1.75, color: '#374151', textAlign: 'left' }}>
                        {disclaimer}
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ px: { xs: 2, sm: 3 }, py: 2, gap: 1, '& > button': { flex: { xs: 1, sm: 'none' }, minHeight: 46, borderRadius: 2.5 } }}>
                    <Button
                        variant="outlined"
                        onClick={handleDisclaimerReject}
                        sx={{ borderColor: '#888', color: '#555', '&:hover': { borderColor: '#333', background: '#f5f5f5' } }}
                    >
                        {language === 'hi' ? 'अस्वीकार करें' : 'REJECT'}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleDisclaimerAccept}
                        sx={{ background: '#b8860b', '&:hover': { background: '#9a7009' }, fontWeight: 600 }}
                    >
                        {language === 'hi' ? 'मैं समझता/समझती हूं' : 'ACCEPT'}
                    </Button>
                </DialogActions>
            </Dialog>
            </main>
            <FooterArea />
        </Fragment>
    )
}
export default HomePageOne